import React from "react";
import UpdatesBanner from "../UpdatesBanner/UpdatesBanner";
import ClubMainPage from "../Club/ClubMainPage";
import "./SocialMarketplace.css";

export default function SocialMarketplace() {
  const userTypes = ["FOOD-PROCESSOR", "AssetDeveloper"];

  return (
    <>
      <UpdatesBanner
        className="socialMarketplace text-white"
        bannerText="Buyers looking for organic farming company"
      />

      <div className="subSectionWrapper">
        <ClubMainPage type={userTypes} />
      </div>
    </>
  );
}
